import { Button } from 'components/button';
import Select from 'components/fields/Select';
import React from 'react';
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdFirstPage,
  MdLastPage,
} from 'react-icons/md';

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  totalPages,
  onPageChange,
}) => {
  return (
    <div className="mt-auto flex flex-col justify-start gap-2 pt-5 lg:flex-row lg:items-center">
      <div className="flex gap-2 flex-row items-center">
        <Button disabled={currentPage <= 0} onClick={() => onPageChange(0)}>
          <MdFirstPage /> <p className='hidden sm:block'>First</p>
        </Button>
        <Button
          disabled={currentPage <= 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <MdArrowBackIosNew /> <p className='hidden sm:block'>Previous</p>
        </Button>
        <Button
          disabled={currentPage + 1 >= (totalPages ?? 1)}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <p className='hidden sm:block'>Next</p>
          <MdArrowForwardIos />
        </Button>

        <Button
          disabled={currentPage + 1 >= (totalPages ?? 1)}
          onClick={() => onPageChange(totalPages - 1 > 0 ? totalPages - 1 : 1)}
        >
          <p className='hidden sm:block'>Last</p>
          <MdLastPage />
        </Button>
      </div>
      <div className="flex flex-col items-center gap-4 text-gray-700 lg:ml-auto xs:flex-row">
        <div>Current page: {Math.max(currentPage + 1, 1)}</div>
        <div>Total items: {totalItems ?? 0}</div>
        <div>Total pages: {Math.max(totalPages ?? 1, 1)}</div>
      </div>
    </div>
  );
};

export default Pagination;
